import React from 'react';
import { useNavigate } from 'react-router-dom';

function BrutalHeader({ minimal }: { minimal?: boolean }) {
  const navigate = useNavigate();

  return (
    <header className="brutal-header">
      <nav className="brutal-nav">
        <a href="/" className="brutal-logo-link">
          <div className="brutal-logo-box">
            <span style={{ lineHeight: 1, fontStyle: 'italic' }}>e</span>
          </div>
          <div className="brutal-logo-text">
            <div className="brutal-logo-name">Efficient</div>
          </div>
        </a>
        {!minimal && (
          <div className="brutal-nav-links">
            <a href="#how-it-works" className="brutal-nav-link">How It Works</a>
            <a href="#industries" className="brutal-nav-link">Industries</a>
            <button className="brutal-cta brutal-nav-cta" onClick={() => navigate('/signup')}>Sign Up</button>
          </div>
        )}
      </nav>
    </header>
  );
}

export default BrutalHeader;
